<script setup>
import SidebarCard from '@/components/cards/SidebarCard.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import AppFooter from '@/components/AppFooter.vue';
import NavTab from '@/components/navigation/NavTab.vue';
import SIdeBarPostList from '@/components/cards/SIdeBarPostList.vue';
import {computed, watch} from 'vue';
import UserPostHeader from '@/components/headers/UserPostHeader.vue';
import AppHeader from '@/components/headers/AppHeader.vue';
import RatingCardComponent from '@/components/cards/RatingCardComponent.vue';
import SideBarProfileCard from '@/components/cards/SideBarProfileCard.vue';
import { useContributorStore } from '@/stores/contributor';
import { useRoute } from 'vue-router';
import SidebarContributorPostList from '@/components/cards/SidebarContributorPostList.vue';
import TopContributorComponent from '@/components/cards/TopContributorComponent.vue';
import {useMiscStore} from "@/stores/misc";
import {ArrowRightIcon} from "@heroicons/vue/16/solid";
import CustomCardImageContent from "@/components/cards/CustomCardImageContent.vue";
import BestOfBestCard from "@/components/cards/BestOfBestCard.vue";

const store = useContributorStore(),
    misc = useMiscStore(),
  route = useRoute();

store.fetchBestOfRatedBusinesses(route.params.username);

const sortData = async (force = false) => {
  await store.fetchBusinesses(route.params.username, route.query.sortBy);
}
  store.fetchBusinesses(route.params.username, route.query.sortBy);
  store.fetchMostVotedBusinesses(route.params.username);
  store.fetchTopRatedBusinesses(route.params.username);
  store.fetchContributor(route.params.username);
  store.fetchPopular('contributions');
  store.fetchBestOfVotedBusinesses(route.params.username);


// Watch for sorting changes to refetch data
watch(
    () => route.query.sortBy,
    (newSortBy, oldSortBy) => {
      if (newSortBy !== oldSortBy) {
        sortData();
      }
    }
);

const businesses = computed(() => store.businesses),
  contributor = computed(() => store.contributor),
 topRated = computed(() => store.topRatedBusinesses),
 mostVoted = computed(() => store.mostVotedBusinesses),
 bestOfVoted = computed(() => store.bestOfVoted),
 bestOfRated = computed(() => store.bestOfRated),
    loading = computed(() => misc.loading),
 loadingTopRated = computed(() => store.loadingTopRatedBusinesses),
 loadingMostVoted = computed(() => store.loadingMostVotedBusinesses),
 topContributors = computed(() => store.popular || store.topRated);
</script>

<template>
  <DefaultLayout :loading="loading">
    <template #header>
      <AppHeader
        :is-post-header="true"
        bg-image="https://images.unsplash.com/photo-1589556045897-c444ffa0a6ff?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      >
        <template #content>
          <UserPostHeader :creator="contributor" />
        </template>
      </AppHeader>
    </template>
    <template #main>
      <NavTab
        :businesses="businesses"
        :contributor="contributor"
      />
    </template>
    <template #aside>
      <SideBarProfileCard :user="contributor" />
      <RatingCardComponent
        :is-side-by-side="true"
        :rating="contributor?.rating"
        :ratings="contributor?.ratings"
        :class="`bg-white rounded-lg`"
      />
      <BestOfBestCard
        v-if="bestOfRated"
        :image="{
          url: bestOfRated?.baseImageUrl
        }"
      >
        <template #body>
          <CustomCardImageContent
            type="rated"
            :business="bestOfRated"
          />
        </template>
      </BestOfBestCard>
      <BestOfBestCard
        v-if="bestOfVoted"
        :image="{
          url: bestOfVoted?.baseImageUrl
        }"
      >
        <template #body>
          <CustomCardImageContent
            type="voted"
            :business="bestOfVoted"
          />
        </template>
      </BestOfBestCard>
      <SidebarCard
        :as-content="topRated?.length > 0 || mostVoted?.length > 0"
        :loading="loadingTopRated"
      >
        <template #header-title>
          StoneSharer's top rated businesses
        </template>
        <template #body>
          <SidebarContributorPostList
            v-if="contributor?.id"
            :businesses="mostVoted"
          />
          <SIdeBarPostList
            v-else
            :businesses="topRated"
          />
        </template>
      </SidebarCard>
      <SidebarCard
        :as-content="mostVoted?.length > 0"
        :loading="loadingMostVoted"
      >
        <template #header-title>
          StoneSharer's popular businesses
        </template>
        <template #body>
          <SidebarContributorPostList
            v-if="contributor?.id"
            :businesses="mostVoted"
          />
          <SIdeBarPostList
            v-else
            :businesses="mostVoted"
          />
        </template>
      </SidebarCard>    

      <SidebarCard :as-content="topContributors?.items?.length > 0">
        <template #header-title>
          Top Contributors
        </template>
        <template #body>
          <TopContributorComponent :contributors="topContributors" />
        </template>
        <template #footer>
          <div class="border-t border-gray-200 pt-0.5 pb-2 px-4 text-right text-red-600">
            <router-link
              :to="`/contributors`"
              class="text-xs font-semibold uppercase"
            >
              View all contributors
              <ArrowRightIcon class="inline h-4 w-4 ml-1" />
            </router-link>
          </div>
        </template>
      </SidebarCard>

      <!-- <SidebarCard>
        <template #header-title>
          Archives
        </template>
        <template #body>
          <ArchivesCompent />
        </template>
      </SidebarCard> -->
    </template>
  </DefaultLayout>
  <AppFooter />
</template>

<style scoped></style>
